import * as Preact from "preact"

import App from "@fae/source/models/App.js"
import Audiomix from "@fae/source/engine/Audiomix.js"

import Step from "@fae/source/models/Step.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"
import CarryOn from "@fae/source/data/games/ember/utility/CarryOn.js"
import ProgressReport from "@fae/source/data/games/school/views/ProgressReport.jsx"

export default function() {
    return (stage) => {
        let steps = []
        const units = Object.values(stage.units).filter((unit) => {
            return unit.affiliation == stage.player.affiliation
        })

        // console.log("calculating levelups")

        // TODO: handle getting SO MUCH experience that you level-up multiple times at once.
        units.forEach((unit) => {
            if(unit.key == "teacher") return
            const partyunit = stage.player.units[unit.key]
            partyunit.experience = unit.experience
            // console.log(partyunit.experience)
            // if(unit.isDead) {
            //     unit.experience += 1
            // } else {
            //     unit.experience += 2
            // }
            // unit.experience = Math.min(unit.experience, unit.maxexperience)

            if(stage.units[unit.key].experience >= stage.units[unit.key].maxexperience) {
            // && stage.units[unit.key].levelups[stage.units[unit.key].level + 1] != undefined) {
                steps.push({"func": () => Audiomix.trigger("Unit:Heal"), "isIgnorable": true})
                const unitKey = unit.key
                steps = steps.concat([
                    SchoolLevelupModalCelebration({unitKey}),
                    SchoolLevelupModalHealthUp({unitKey}),
                    SchoolLevelupModal({unitKey}),
                ])
            }
        })
        return steps
    }
}

function SchoolLevelupModalCelebration({unitKey}) {
    return PlotSteps.CustomViewModal({
        "isUnskippable": false,
        "view": (stage) => {
            if(stage == undefined) return
            const unit = stage.units[unitKey]
            if(unit == undefined) return
            return (
                <div class="SchoolLevelupModal">
                    <img class="Portrait" src={unit.portraits?.neutral}/>
                    <div class="Details">
                        <section class="HeaderSection">
                            <div class="Declaration">Level Up!!</div>
                            <ProgressReport stage={stage} unit={unit}/>
                        </section>
                    </div>
                </div>
            )
        }
    })
}

function SchoolLevelupModalHealthUp({unitKey}) {
    unitKey = unitKey || "nerd"
    return PlotSteps.CustomViewModal({
        "isUnskippable": false,
        "view": (stage) => {
            if(stage == undefined) return
            const unit = stage.units[unitKey]
            if(unit == undefined) return
            return (
                <div class="SchoolLevelupModal">
                    <img class="Portrait" src={unit.portraits?.neutral}/>
                    <div class="Details">
                        <section class="HeaderSection">
                            <div class="Declaration">Level Up!!</div>
                            <ProgressReport stage={stage} unit={unit}/>
                            <div class="Description">Health: {unit.maxhealth / 10}hp <span class="Arrow"/> {(unit.maxhealth / 10) + 1}hp</div>
                            <div class="Description">Power: {unit.power / 10}pow <span class="Arrow"/> {(unit.power / 10) + 1}pow</div>
                        </section>
                    </div>
                </div>
            )
        }
    })
}

function SchoolLevelupModal({unitKey}) {
    unitKey = unitKey || "nerd"
    return PlotSteps.CustomViewModal({
        "isUnskippable": true,
        "view": (stage) => {
            if(stage == undefined) return
            const unit = stage.units[unitKey]
            if(unit == undefined) return
            return (
                <div class="SchoolLevelupModal">
                    <img class="Portrait" src={unit.portraits?.neutral}/>
                    <div class="Details">
                        <section class="HeaderSection">
                            <div class="Declaration">Pick a Perk:</div>
                        </section>
                        <section class="PerksSection" element={unit.equippedItem?.element}>
                            {unit.levelupPerks.map((perk) => {
                                return (
                                    <div class="Perk" onClick={onClickPerk(stage, unit, perk)}
                                        hasUnlocked={unit.flags && unit.flags["has unlocked perk#" + perk.key]}>
                                        <div class="Title">{perk.title}</div>
                                        <div class="Description">{perk.description}</div>
                                    </div>
                                )
                            })}
                        </section>
                    </div>
                </div>
            )
        }
    })
}

function onClickPerk(stage, unit, perk) {
    return function(event) {
        if(unit.flags && unit.flags["has unlocked perk#" + perk.key] == true) return

        const partyunit = stage.player.units[unit.key]

        partyunit.flags = unit.flags

        unit.experience -= unit.maxexperience
        unit.experience = Math.max(0, unit.experience)
        partyunit.experience = unit.experience

        unit.level += 1
        partyunit.level = unit.level

        // TODO: use the unit.levelups here!!!

        unit.maxhealth += 10
        partyunit.maxhealth = unit.maxhealth

        unit.power += 10
        partyunit.power = unit.power

        unit.maxexperience += 10
        partyunit.maxexperience = unit.maxexperience

        unit.flags = unit.flags || {}
        unit.flags["has unlocked perk#" + perk.key] = true
        if(perk.power != undefined) {
            unit.power = unit.power || 0
            unit.power += perk.power
            partyunit.power = unit.power
        }
        if(perk.maxhealth != undefined) {
            unit.maxhealth += perk.maxhealth
            partyunit.maxhealth = unit.maxhealth
        }
        if(perk.moverange != undefined) {
            unit.moverange += perk.moverange
            partyunit.moverange = unit.moverange
        }
        if(perk.trueattackrange != undefined) {
            unit.trueattackrange = perk.trueattackrange
            partyunit.trueattackrange = unit.trueattackrange
        }
        if(perk.property != undefined) {
            // console.log(perk.property)
            unit.properties = unit.properties || []
            partyunit.properties = unit.properties || []
            unit.properties.push(perk.property)
            partyunit.properties.push(perk.property)
        }
        if(perk.passiveKey != undefined) {
            unit.passiveKeys = unit.passiveKeys || []
            partyunit.passiveKeys = partyunit.passiveKeys || []
            unit.passiveKeys.push(perk.passiveKey)
            partyunit.passiveKeys.push(perk.passiveKey)
        }
        if(perk.skillKey != undefined) {
            unit.skillKeys = unit.skillKeys || []
            partyunit.skillKeys = partyunit.skillKeys || []
            unit.skillKeys.push(perk.skillKey)
            partyunit.skillKeys.push(perk.skillKey)
        }
        CarryOn(stage)
    }
}
